import React, { useEffect, useRef, useState } from 'react';
import { Switch, Typography, TableRow } from '@mui/material';
import { debounce } from 'lodash';
import TableCell from '@mui/material/TableCell';
import { useDrag, useDrop } from 'react-dnd';
import { MoreOptions } from '../../components/Table/assets/MoreOptions';
import * as Icons from '@mui/icons-material';
import Avatar from '@mui/material/Avatar';

const ItemTypes = {
  BOX: 'ROW',
};
const StatusManagementRow = ({
  row,
  index,
  moveRow,
  clickOnDelete,
  clickOnEdit,
  schema,
}) => {
  const ref = useRef(null);
  const [value, setValue] = useState(row);
  const IconComponent = Icons[value.icon?.name];

  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.BOX },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: 'ROW',
    hover: (draggedItem) => {
      if (draggedItem.index !== index) {
        moveRow(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  drag(drop(ref));

  const debouncedOnChange = debounce(handleDebouncedOnChange, 500);

  function handleDebouncedOnChange(row, column, checked) {
    const data = {};
    data[column] = checked;

    schema.client.update(row?.id, data).then((res) => {});

    setValue({ ...value, [column]: checked });
  }

  useEffect(() => {
    setValue(row);
  }, [row]);

  return (
    <TableRow ref={ref} style={{ opacity: isDragging ? 0.5 : 1 }}>
      <TableCell>
        <Avatar
          sx={{
            background: value.color?.color,
              width: 26,
              height: 26,
              '& .MuiSvgIcon-root':{
                fontSize: '20px'
              }
          }}
        >
          {value?.icon && (
            <>{IconComponent ? <IconComponent color={'#fff'} /> : null}</>
          )}
        </Avatar>
      </TableCell>
      <TableCell>
        <Typography variant={'caption'}>{row.name}</Typography>
      </TableCell>
      <TableCell>
        <Switch
          checked={value?.end_status}
          onChange={(event, checked) => {
            debouncedOnChange(row, 'end_status', checked);
          }}
        />
      </TableCell>
      <TableCell>
        <Switch
          checked={value?.booked_end_status}
          onChange={(event, checked) => {
            debouncedOnChange(value, 'booked_end_status', checked);
          }}
        />
      </TableCell>
      <TableCell>
        <Switch
          checked={value?.active}
          onChange={(event, checked) => {
            debouncedOnChange(value, 'active', checked);
          }}
        />
      </TableCell>
      <TableCell>
        <MoreOptions
          clickOnEdit={() => {
            clickOnEdit(value);
          }}
          clickOnDelete={() => {
            clickOnDelete(value);
          }}
        />
      </TableCell>
    </TableRow>
  );
};
export default StatusManagementRow;
